"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = {
    dateFormat: "dd/mm/yyyy",
};
//# sourceMappingURL=config.js.map